import { Button } from "@mui/material";
import { FC, useRef } from "react";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";

export const ConfirmModal: FC<any> = ({ children }) => {
  const { t } = useTranslation();

  const refContainer = useRef(null) as any;
  const refContent = useRef(null) as any;

  const closeModal = () => {
    refContainer.current.classList.add("before-close");
    refContent.current.classList.add("before-close");
    setTimeout(() => {
      refContent.current.classList.remove("show");
      refContainer.current.classList.remove("show");
      refContainer.current.classList.remove("before-close");
      refContent.current.classList.remove("before-close");
    }, 200);
  };

  const onBackdropClick = (e: any) => {
    if (e.target.classList.contains("ConfirmModal-container")) {
      closeModal();
    }
  };

  return (
    <div
      id="confirm_modal"
      ref={refContainer}
      onClick={(e) => onBackdropClick(e)}
      className="ConfirmModal-container"
    >
      <div
        id="confirm_modal_content"
        ref={refContent}
        className="ConfirmModal-content"
      >
        <div className="ConfirmModal-header">
          <h4 id="confirm_modal_title">Burası Title Alanı</h4>
        </div>
        <div className="ConfirmModal-body" id="confirm_modal_body"></div>
        <div className="ConfirmModal-footer px-3">
          <Box sx={{ display: "flex", px: 3 }}>
            <Button
              id="dismiss_btn"
              onClick={closeModal}
              variant="outlined"
              sx={{ mr: 1 }}
            >
              {t("close")}
            </Button>

            <Button
              id="ok_btn"
              className="secondary"
              onClick={closeModal}
              variant="contained"
            >
              {t("confirm")}
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
};
